import { Injectable } from '@angular/core';
import { PermissionTypes, PFWmsEntities } from '@pf/shared-common';
import { AbstractRouteBuilder } from '@pf/shared-services';
import { buildWmsPermissionPath } from '@pf/shared/util-platform';

@Injectable()
export class RoutesForException extends AbstractRouteBuilder {
    permissionType = buildWmsPermissionPath(
        PermissionTypes.Modify,
        PFWmsEntities.Exception
    );
}
